export const AREA = { label: "Area", value: "AREA"};
export const LINE = { label: "Line", value: "LINE"};
export const CANDLESTICK = { label: "Candlestick", value: "CANDLESTICK"};
export const HEIKIN_ASHI = { label: "Heikin Ashi", value: "HEIKIN_ASHI"};
export const RENKO = { label: "Renko", value: "RENKO"};
export const KAGI = { label: "Kagi", value: "KAGI"};
export const POINT_FIGURE = { label: "Point & Figure", value: "POINT_FIGURE"};



/** WEBPACK FOOTER **
 ** ./src/scripts/constants/ChartTypes.js
 **/